module.exports = __webpack_public_path__ + "static/the-talent-code-b7344923b20c0ca2e702b48ca2ccb765.jpg";